<template>
  <div v-if="leaderboard.length">
    <div v-if="leaderboard.length" class="row justify-center items-end leaderboard-top-three">
      <LeaderPosition :leader="leaderboard[1]" :position="'two'" />
      <LeaderPosition :leader="leaderboard[0]" :position="'one'" />
      <LeaderPosition :leader="leaderboard[2]" :position="'three'" />
    </div>
    <div class="leaderboard-container" v-if="leaderboard">
      <div class="leaderboard-table">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-5 leaderboard-head" style="border-top-left-radius:30px">Name</div>
          <div class="col-4 leaderboard-head">Team</div>
          <div class="col-2 leaderboard-head">Points</div>
          <!-- <div class="col-1 leaderboard-head">Time</div> -->
          <!-- <div class="col-2 leaderboard-head" style="border-top-right-radius:30px;text-align: right;">Time</div> -->
        </div>
        <div v-for="(board, index) in leaderboard" :key="index" class="row">
          <template v-if="![0,1,2].includes(index)">
            <div class="col-1 leaderboard-content text-center" style="background:none;border:none;">{{index + 1}}</div>
            <div class="col-5 leaderboard-content" style="border-radius: 20px 0px 0px 20px;">{{board.name}}</div>
            <div class="col-4 leaderboard-content">{{board.team_name}}</div>
            <div class="col-2 leaderboard-content">{{board.total_score}}</div>
            <!-- <div class="col-1 leaderboard-content">{{board.total_time}}</div> -->
            <!-- <div class="col-2 leaderboard-content" style="border-radius: 00px 20px 20px 0px;text-align: right">
              {{board.country}}</div> -->
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeaderPosition from './LeaderPosition';
export default {
  components: { LeaderPosition },
  props: ['tab'],
  data() {
    return {
      leaderboard: [
        {
          name: '',
          team_name: '',
          total_score: "",
          total_time: '',
          country: '',
          image: '',
        },
        {
          name: '',
          team_name: '',
          total_score: "",
          total_time: '',
          country: '',
          image: '',
        },
        {
          name: '',
          team_name: '',
          total_score: "",
          total_time: '',
          country: '',
          image: '',
        },
      ],
      missions: {
        "Elementary-Level": 1,
        "Jonin-Level": 2,
        "Senior-Level": 3,
      }
    }
  },
  mounted() {
    this.$API.general.getHomeLeaderboard(this.missions[this.tab])
      .then(response => {
        this.leaderboard = response;
      })
  }
}
</script>
<style>
.leaderboard-container {
  background: #FFF;
  width: 820px;
  max-width: 820px;
  border-radius: 100px;
  padding: 40px;
  min-height: 500px;
}

.leaderboard-top-three {
  margin-bottom: -20px;
}

.lb-positions {
  width: 68px;
  background: #fdae38;
  border-radius: 10px 10px 0 0;
  position: relative;
  margin-left: 36px
}

.lb-first-three-details {
  color: #FFF;
  font-size: 10px;
  margin-bottom: 2px !important;
}

.lb-positions-one {
  height: 100px;
  background: #f75435;
}

.lb-positions-two {
  height: 80px;
  background: #fdae38;
}

.lb-positions-three {
  height: 60px;
  background: #4fa3a5;
}

.lb-positions-number {
  color: #FFF;
  font-weight: bold;
  text-align: center;
  font-size: 24px;
}

.lb-positions-points {
  color: #FFF;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
}

.leaderboard-head {
  background: #252634;
  color: #FFF;
  padding: 10px 14px;
  font-weight: bold;
}

.leaderboard-content {
  background: #e0f1f9;
  color: #252634;
  padding: 14px 14px;
  margin-top: 20px;
  /* border: 1px #ededed solid */
}
</style>